<!--
화면배율조정 mixin
믹스인 참조한 컴포넌트에서 화면배율 조정 + - 버튼은 직접구현해야함.
------------------------------------

-->

<script>
    export default {
        props: {
        },
        data: function () {
            return {

                /**
                 * (integer) 기본값
                 */
                screenRatioDefault: 18,

                /**
                 * (integer) 화면배율 조정을 위한 html태그 font-size (px 단위빼고 숫자만 저장)
                 */
                screenRatio: 18,

                // 화면배율 옵션
                screenRatioOptions: [12, 14, 16, 18, 20, 22, 24],
            };
        },
        mounted() {
            // 화면배율 초기 조회
            this.loadScreenRatioFromCookie();
        },
        computed: {

            /**
             * 현재 선택값 text
             */
            screenRatioText: function () {
                let text = this.screenRatio + 'px';
                if (this.screenRatio === this.screenRatioDefault) {
                    text += '(기본)';
                }
                return text;
            },

            /**
             * 화면배율 zoom-out disabled
             */
            screenRatioZoomOutDisabled: function () {
                return this.screenRatio === this.screenRatioOptions[0];
            },

            /**
             * 화면배율 zoom-in disabled
             */
            screenRatioZoomInDisabled: function () {
                return this.screenRatio === this.screenRatioOptions[this.screenRatioOptions.length - 1];
            },

        },
        methods: {


            // 확대
            screenRatioZoomIn() {
                if (this.screenRatioZoomInDisabled) {
                    return;
                }
                let found = _.find(this.screenRatioOptions, (size) => {
                    return size > this.screenRatio;
                });
                if (found) {
                    this.setScreenRatio(found);
                }
            },

            // 축소
            screenRatioZoomOut() {
                if (this.screenRatioZoomOutDisabled) {
                    return;
                }
                let found = _.findLast(this.screenRatioOptions, (size) => {
                    return size < this.screenRatio;
                });
                if (found) {
                    this.setScreenRatio(found);
                }
            },


            /**
             * 화면배율조정 값 반영
             * @param size (integer) px단위 빼고 숫자만 전달 e.g. "12"
             */
            setScreenRatio(size) {
                Cookies.set('screen-ratio', size, { expires: 3650 });
                document.documentElement.style.fontSize = size + 'px';
                this.screenRatio = size;
            },

            /**
             * 화면배율조정 값 초기 조회
             */
            loadScreenRatioFromCookie() {

                // 화면배율 초기값
                let screen_ratio = Cookies.get('screen-ratio');
                //console.log('screen_ratio : ' + screen_ratio);
                if (isNaN(screen_ratio)) {
                    screen_ratio = this.screenRatioDefault;

                } else {
                    screen_ratio = parseInt(screen_ratio);

                }
                //console.log('screen_ratio : ' + screen_ratio);
                this.setScreenRatio(screen_ratio);
            },
        }, // end methods
    }
</script>